import { composeIO } from 'react-compose-io'
import { regularizacaoTitulosIO } from './RegularizacaoTitulos.IO'
import { RegularizacaoTitulosView } from './RegularizacaoTitulos.View'

export const RegularizacaoTitulos = composeIO(RegularizacaoTitulosView, regularizacaoTitulosIO)
